import { basicInitialState } from '../_utils/basicInitialState';
import { TPersonState } from './person';

export const personInitialState: TPersonState = {
  ...basicInitialState,
  person: null
};
